"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketPayloadEventSubType = 'WebsocketPayload';
exports.WebsocketConnectEventSubType = 'WebsocketConnect';
exports.OfferAutopopPayloadType = 'OfferAutopopPayload';
exports.SendToUserEventSubType = 'SendToUser';
